<template>
  <div class="flex flex-col w-full">
    <Nav style="margin-bottom: 60px" :data="getNavElements" />
  
    <router-view></router-view>

  </div>
</template>

<script>
import data from "@/data/config.json";
import axios from "axios";

import Nav from "@/components/Navigation.vue";

export default {
  name: "home",
  data() {
    return {
      data,
      category: { users: [] },
      categories: [],
      sections: null
    };
  },
  components: {
    Nav
  },
  created() {
    if (this.data.configId) {
      axios.get(
        `https://edgeryders.eu/webkit_components/topics.json?serializer=event&tags=webcontent`
      ).then(({ data }) => {
        var post = data.find(post => post.id === this.data.configId);
        var json = this.getJson(post.cooked);
        this.sections = json.sections;
      });
    } else {
      this.sections = this.data.sections;
    }
  },
  methods: {
    getSectionData(type) {
      return this.sections.find(section => section.type === type) || {};
    },
    getNavElements() {
      if (this.sections.length) {
      var navArray = this.sections.map(function(el) {
            if (el.id) {
              return {
                title: el.title,
                id: el.id,
              } 
            }
          });
      return navArray.filter(function (el) {
          return el != null;
      });
      }
    }
  },
  computed: {
  }
};
</script>
